class PublicMaatData {
  data = {};

  setData(key, value) {
    this.data[key] = value;
  }

  getData() {
    return this.data;
  }
}

export default new PublicMaatData();
